module.exports = __webpack_public_path__ + "img/nodate.7bfdab29.png";